import snapshot from "./generated/site-content.json" with { type: "json" };
import {
  dailyRecipesSchema,
  reflectionCardsSchema,
} from "./schemas";

/**
 * The collections are authored in Sanity and pulled into
 * `generated/site-content.json` by `scripts/fetch-content.mjs`. The snapshot is
 * committed, so the build stays hermetic and content changes stay reviewable in
 * git.
 *
 * Parsing happens here at module load, exactly as it did when the content was
 * inline: an invalid snapshot fails `npm run build` rather than reaching a
 * visitor.
 */
export const reflectionCards = reflectionCardsSchema.parse(
  snapshot.reflectionCards,
);

export const dailyRecipes = dailyRecipesSchema.parse(snapshot.dailyRecipes);
